module.exports = __webpack_public_path__ + "static/tree-15b634ee4f8f243a0ffaf7197bddb423.png";